import {IssueMarkdownViewer} from '@github-ui/commenting'
import {useFeatureFlags} from '@github-ui/react-core/use-feature-flag'
import type {ReactionViewerGroups$key, ReactionViewerUser$key} from '@github-ui/reaction-viewer'
import {ReactionViewer} from '@github-ui/reaction-viewer'
import type {SafeHTMLString} from '@github-ui/safe-html'
import {Box} from '@primer/react'
import {type RefObject, useCallback} from 'react'
import {useRelayEnvironment} from 'react-relay'

import {commitUpdateIssueBodyMutation} from '../mutations/update-issue-body-mutation'
import {AddTasklistButton} from './AddTasklistButton'

export type IssueBodyViewerProps = {
  id: string
  html: SafeHTMLString
  markdown: string
  viewerCanUpdate: boolean
  reactionGroups: ReactionViewerGroups$key
  viewer: ReactionViewerUser$key
  onLinkClick?: (event: MouseEvent) => void
  locked: boolean
  viewerRef?: RefObject<HTMLDivElement>
  issueBodyRef?: React.RefObject<HTMLDivElement>
}

export function IssueBodyViewer({
  id,
  html,
  markdown,
  viewerCanUpdate,
  reactionGroups,
  viewer,
  onLinkClick,
  locked,
  viewerRef,
  issueBodyRef,
}: IssueBodyViewerProps) {
  const {tasklist_block} = useFeatureFlags()
  const environment = useRelayEnvironment()

  const onSave = useCallback(
    (newBody: string, onCompleted: () => void, onError: () => void) => {
      commitUpdateIssueBodyMutation({
        environment,
        input: {issueId: id, body: newBody},
        onCompleted,
        onError,
      })
    },
    [environment, id],
  )
  return (
    <Box sx={{display: 'flex', flexDirection: 'column', gap: 4, p: 3}} ref={issueBodyRef}>
      <IssueMarkdownViewer
        html={html}
        markdown={markdown}
        viewerCanUpdate={viewerCanUpdate}
        onSave={onSave}
        onLinkClick={onLinkClick}
      />
      <Box sx={{flexDirection: 'row', display: 'flex', alignItems: 'left'}}>
        {tasklist_block && viewerRef && viewerCanUpdate && <AddTasklistButton bodyRef={viewerRef} />}
        <ReactionViewer subjectId={id} reactionGroups={reactionGroups} viewer={viewer} locked={locked} />
      </Box>
    </Box>
  )
}

try{ IssueBodyViewer.displayName ||= 'IssueBodyViewer' } catch {}